import React, { useState, useEffect } from "react";
import { Eye, EyeOff } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../component/Footer";
import SellerNavbar from "../../component/SellerNavbar";
import axios from "axios"; // Import axios
import { baseurl } from "../../Baseurl"; // Assuming you have baseurl defined somewhere

const SellerLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false); // Add loading state

  const navigate = useNavigate();

useEffect(() => {
    const sellerId = localStorage.getItem("seller_id");
    if (sellerId) {
      navigate("/seller/dashboard");
    }
  }, [navigate]);



  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form from submitting the default way
    setLoading(true); // Start the spinner
    try {
      // Sending email and password to the backend
      const response = await axios.post(`${baseurl}seller_login`, {
        email,
        password,
      });

      // If login is successful, store the data in localStorage
      localStorage.setItem("seller_id", response.data.data.id);
      localStorage.setItem("seller_email", response.data.data.email);
      localStorage.setItem("seller_first_name", response.data.data.first_name);

      // Redirect to dashboard or the desired page
      navigate("/seller/dashboard");
    } catch (error) {
      // If there's an error (e.g., invalid credentials), display the error message
      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage("An error occurred during login.");
      }
    } finally {
      setLoading(false); // Stop the spinner after API call completes
    }
  };

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 justify-content-center">
              <div className="col-md-5">
                <div className="reviewcls">
                  <h4 className="review-form-heading">Login to Seller Account</h4>
                  <p className="payttl">
                    Please log in using your email and password.
                  </p>
                  <hr />
                  <form onSubmit={handleLogin} className="contact-form text-start">
                    <div className="row g-2">
                      <div className="col-12">
                        <label htmlFor="email" className="form-label">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Enter your email address"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="password" className="form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            className="form-control"
                            placeholder="Enter your password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <span
                            className="input-group-text"
                            onClick={togglePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <EyeOff /> : <Eye />}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Display error message if login fails */}
                    {errorMessage && (
                      <div className="mt-3 text-danger">
                        <p>{errorMessage}</p>
                      </div>
                    )}

                    <div className="mt-3">
                      <button type="submit" className="btn submitbtnn w-100" disabled={loading}>
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>{" "}
                            Logging in...
                          </>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </div>
                  </form>

                  <div className="mt-1 text-start">
                    <p>
                      <Link
                        to="/seller/forgot-password"
                        className="text-primary claslnk"
                      >
                        Lost your password?
                      </Link>
                    </p>
                  </div>

                  <div className="mt-3 text-center">
                    <p>
                      Don't have an account?{" "}
                      <Link
                        to="/seller/register"
                        className="text-primary claslnk"
                      >
                        Create Account
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default SellerLogin;
